import { get, isNil } from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import settings from 'src/settings/settings';
import { checkFullyContributedIRA } from 'src/utils/funds/funds-utility';
import { getSubState, ApplicationState } from '../../types';
import { getUserState } from '../../user/PersonalInformation/personalInformation.selectors';

const slice = getSubState<ApplicationState, ApplicationState['IRALimit']>(
  'IRALimit'
);

export const getIRALimit = createSelector(slice, (IRALimit) => IRALimit);

export const getIRALimitData = createSelector(getIRALimit, (IRALimit) =>
  IRALimit ? IRALimit.data : IRALimit
);

export const getIRACutOffDate = (state) =>
  get(state, 'IRALimit.windowCheck.iraContributionPeriodCutoffDate');

export const getWindowCutoffDate = createSelector(
  getIRACutOffDate,
  getUserState,
  (IRACutOffDate, userState) => {
    return isNil(IRACutOffDate)
      ? 'tax filing deadline'
      : userState === 'MA' || userState === 'ME'
      ? settings.iraContributionWindowCloseDate.format('MM/DD/YYYY')
      : moment(IRACutOffDate).format('MM/DD/YYYY');
  }
);

/**
 * Returns true/false if the user has fully contributed to their IRA
 * @param state
 * @returns {boolean}
 */
export const getIsFullyContributedIRA = createSelector(
  getIRALimitData,
  checkFullyContributedIRA
);

/**
 * Returns boolean if we are "in-season"; able to contribute to both current and prior year.
 */
export const getWithinIRAPriorYearContributionPeriod = createSelector(
  getIRALimitData,
  (data) => Boolean(data.withinIRAPriorYearContributionPeriod)
);
